export type Locale = "en" | "ja";

export const locale: Locale =
  typeof window !== "undefined" && /^\/ja(?:\/|$)/.test(window.location.pathname)
    ? "ja"
    : "en";

export const isJapanese = locale === "ja";
export const homePath = isJapanese ? "/ja/" : "/";
export const alternatePath = isJapanese ? "/" : "/ja/";

const japanese: Record<string, string> = {
  "SuraYomi home": "SuraYomi ホーム",
  Close: "閉じる",
  "Sign in": "ログイン",
  "Create account": "アカウント作成",
  "YOUR SURAYOMI STUDIO": "SuraYomi スタジオ",
  "Welcome back.": "おかえりなさい。",
  "Bring your words to life.": "あなたの言葉に、声を。",
  "Sign in to create, save, and return to your favorite voices.":
    "ログインして、音声の作成・保存・お気に入りの声の再利用ができます。",
  "Start with 50 credits each month—no card needed.":
    "毎月50クレジットから無料で始められます。カード登録は不要です。",
  "Authentication is being connected. Please check back in a moment.":
    "認証サービスを接続しています。しばらくしてからもう一度お試しください。",
  "Continue with Google": "Googleで続ける",
  "or continue with email": "またはメールアドレスで続ける",
  "Email address": "メールアドレス",
  Password: "パスワード",
  "At least 6 characters": "6文字以上",
  "Create free account": "無料アカウントを作成",
  "New to SuraYomi?": "SuraYomiは初めてですか？",
  "Already have an account?": "すでにアカウントをお持ちですか？",
  "Create an account": "アカウントを作成",
  "That email or password doesn’t match.": "メールアドレスまたはパスワードが一致しません。",
  "That email already has an account.": "このメールアドレスはすでに登録されています。",
  "The sign-in window was closed.": "ログイン画面が閉じられました。",
  "Please choose a stronger password.": "より安全なパスワードを設定してください。",
  "We couldn’t sign you in just now. Please try again.":
    "現在ログインできません。もう一度お試しください。",
  "Verify your email": "メールアドレスを確認",
  "ONE QUICK STEP": "あと1ステップ",
  "Check your inbox.": "受信トレイをご確認ください。",
  "We sent a verification link to": "確認リンクを送信しました：",
  "Verify your address, then return here and sign in.":
    "メールアドレスを確認してから、こちらに戻ってログインしてください。",
  "Back to sign in": "ログインに戻る",
  Pause: "一時停止",
  Play: "再生",
  Download: "ダウンロード",
  "Remove audio": "音声を削除",
  "Saved presets": "保存済みプリセット",
  "Save a preset to reuse its voice, controls, and seed.":
    "プリセットを保存すると、声・調整値・シードをいつでも再利用できます。",
  "Delete preset": "プリセットを削除",
  "VOICE PRESET": "ボイスプリセット",
  "Save voice preset": "ボイスプリセットを保存",
  "Save this sound.": "この声を保存。",
  "Keep every detail—including the seed—ready for your next read.":
    "シードを含むすべての設定を保存し、次回すぐに再現できます。",
  "Preset name": "プリセット名",
  "Warm documentary": "温かみのあるドキュメンタリー",
  "Save preset": "プリセットを保存",
  "Your voices": "あなたの声",
  "New voice": "新しい声",
  "Make a reusable voice": "繰り返し使える声を作成",
  "Use 5–20 seconds of clear, single-speaker audio. Only clone a voice you have permission to use.":
    "1人の話者による明瞭な音声を5〜20秒使用してください。クローンの許可を得た声のみ利用できます。",
  "Voice sample source": "音声サンプルの入力方法",
  "Record here": "ここで録音",
  "Upload a clip": "音声をアップロード",
  "Start recording": "録音を開始",
  "Stop recording": "録音を停止",
  "Record a clean voice sample": "クリアな音声を録音",
  "Listening…": "録音中…",
  "Tap once, speak naturally, then stop.":
    "タップして自然に話し、終わったら停止してください。",
  seconds: "秒",
  "Voice sample ready": "音声サンプルの準備完了",
  "Record again": "録音し直す",
  "Your browser does not support audio playback.":
    "このブラウザでは音声を再生できません。",
  "Your microphone is used only while recording. Audio is sent when you save the voice.":
    "マイクは録音中だけ使用され、音声は声を保存するときに送信されます。",
  "Recording is not supported in this browser. You can still upload a clip.":
    "このブラウザでは録音できません。音声ファイルのアップロードは利用できます。",
  "We couldn’t capture audio. Please try again or upload a clip.":
    "音声を録音できませんでした。もう一度試すか、音声ファイルをアップロードしてください。",
  "Record at least 5 seconds for a clear voice.":
    "クリアな声を作るため、5秒以上録音してください。",
  "Record or upload a voice sample first.":
    "先に音声サンプルを録音またはアップロードしてください。",
  "Give this voice a name before saving.":
    "保存する前に、この声に名前を付けてください。",
  "Microphone access was blocked. Allow it in your browser settings or upload a clip.":
    "マイクへのアクセスがブロックされました。ブラウザ設定で許可するか、音声ファイルをアップロードしてください。",
  "We couldn’t open the microphone. Please try again or upload a clip.":
    "マイクを開けませんでした。もう一度試すか、音声ファイルをアップロードしてください。",
  "Drop or choose an audio clip": "音声クリップをドロップまたは選択",
  "WAV, MP3, M4A, WebM · up to 8 MB":
    "WAV・MP3・M4A・WebM（最大8MB）",
  "Voice name": "声の名前",
  "My narrator": "マイナレーター",
  Language: "言語",
  "Words spoken in the clip": "クリップ内で話している言葉",
  recommended: "推奨",
  "Type the exact transcript for the clearest clone…":
    "より自然なクローンのため、音声の正確な文字起こしを入力…",
  "Save voice": "声を保存",
  "We couldn’t save that voice.": "声を保存できませんでした。",
  "We couldn’t remove that voice.": "声を削除できませんでした。",
  "Account details could not be loaded.": "アカウント情報を読み込めませんでした。",
  "Checkout was canceled. Nothing was charged.":
    "チェックアウトをキャンセルしました。請求は発生していません。",
  "Confirming your payment…": "お支払いを確認しています…",
  "Payment confirmed. Your account is ready.":
    "お支払いを確認しました。アカウントの準備が整いました。",
  "Payment is still processing. Your account will update automatically.":
    "お支払いは処理中です。完了後、アカウントは自動的に更新されます。",
  "Checkout could not be opened.": "チェックアウトを開けませんでした。",
  "Billing settings could not be opened.": "請求設定を開けませんでした。",
  "Credit checkout could not be opened.": "追加クレジットの購入画面を開けませんでした。",
  "Give us a few words to bring to life.": "声にしたい文章を入力してください。",
  "Save or select a cloned voice first.": "クローン音声を保存または選択してください。",
  "The voice could not be created.": "音声を作成できませんでした。",
  Studio: "スタジオ",
  Voices: "音声",
  Pricing: "料金",
  About: "SuraYomiについて",
  Account: "アカウント",
  "Display name": "表示名",
  "How should we address you?": "表示するお名前",
  "Monthly credits": "月間クレジット",
  "Available credits": "利用可能クレジット",
  "Free plan": "Freeプラン",
  "Creator plan": "Creatorプラン",
  "Studio plan": "Studioプラン",
  Ends: "終了日",
  "will not renew": "更新されません",
  Renews: "更新日",
  "Payment needs attention": "お支払い方法をご確認ください",
  "Add extra credits": "追加クレジット",
  "Purchased credits do not expire.": "購入した追加クレジットに有効期限はありません。",
  "Manage billing & cancellation": "請求と解約を管理",
  left: "残り",
  "Sign out": "ログアウト",
  "Toggle menu": "メニューを切り替え",
  "Switch to light theme": "ライトテーマに切り替え",
  "Switch to dark theme": "ダークテーマに切り替え",
  "Text, with a": "ことばに、",
  "soul.": "こころを。",
  "Create expressive AI text-to-speech. Choose a studio voice, design one from a prompt, or clone your own voice with consent—then refine and download.":
    "文章を表情豊かなAI音声へ。スタジオ音声を選ぶ、プロンプトから声をデザインする、または同意を得た自分の声をクローンし、整えてダウンロードできます。",
  "10 languages": "10言語対応",
  "Voice cloning": "ボイスクローン",
  "Private by design": "プライバシー重視",
  "Speech studio": "音声スタジオ",
  "Create, refine, and download": "作成・調整・ダウンロード",
  Presets: "プリセット",
  "Save settings": "設定を保存",
  "Write your words": "文章を書く",
  "Paste a script or begin with a sample.": "原稿を貼り付けるか、サンプルから始めましょう。",
  "Write something worth hearing…": "声にしたい言葉を書いてください…",
  "Try a sample": "サンプルを試す",
  "Quiet wonder": "静かな驚き",
  "Japanese welcome": "日本語のごあいさつ",
  "Product story": "プロダクト紹介",
  "Copy text": "文章をコピー",
  "Shape the voice": "声を形づくる",
  "Start familiar, invent freely, or preserve a real voice.":
    "定番の声から始める、自由に創る、大切な声を残す。",
  "Studio voice": "スタジオ音声",
  "Curated & consistent": "厳選された安定の声",
  "Design a voice": "声をデザイン",
  "Describe any sound": "言葉で自由に表現",
  "Clone a voice": "声をクローン",
  "Recreate with consent": "同意を得て再現",
  "Selected voice": "選択中の声",
  voices: "種類の声",
  "Choose studio voice": "スタジオ音声を選択",
  "Describe a person, mood, accent, texture, or performance direction. A voice will be designed for this read.":
    "人物像、感情、アクセント、声の質感、演技の方向性を自由に記述してください。今回の文章に合う声をデザインします。",
  "Voice description": "声の説明",
  "A warm Japanese woman in her thirties, close-mic, soft smile, calm documentary pacing…":
    "30代の温かみのある日本人女性。近接マイク、やさしい笑顔、落ち着いたドキュメンタリー調…",
  "Warm storyteller": "温かい語り手",
  "Bright anime heroine": "明るいアニメヒロイン",
  "Deep cinematic narrator": "重厚な映画ナレーター",
  "Gentle audiobook": "やさしいオーディオブック",
  "Performance direction": "演技の方向性",
  optional: "任意",
  "Read intimately, with a little wonder…":
    "親しみを込め、少し驚きを感じさせるように…",
  "Voice controls": "音声コントロール",
  "Reset controls": "設定をリセット",
  "Speaking pace": "話す速さ",
  Expressiveness: "表現力",
  "Higher values introduce more variation.": "高いほど表現の変化が大きくなります。",
  Steady: "安定",
  Vivid: "鮮やか",
  Natural: "自然",
  "Voice seed": "ボイスシード",
  "Reuse the same seed and settings for consistent output.":
    "同じシードと設定を使うと、一貫した音声を再現できます。",
  "Lock this number to reproduce a voice.": "この数字を固定すると声を再現できます。",
  "Randomize seed": "シードをランダム化",
  Advanced: "詳細設定",
  Focus: "フォーカス",
  "Vocabulary range": "語彙の幅",
  "Repetition guard": "繰り返し抑制",
  "Download format": "ダウンロード形式",
  "Free credits": "無料クレジット",
  "Creator credits": "Creatorクレジット",
  "Studio credits": "Studioクレジット",
  "Free credits reset monthly": "無料クレジットは毎月リセット",
  "Included credits reset each billing period":
    "プラン付属クレジットは請求期間ごとにリセット",
  "Giving your words a voice…": "ことばに声を吹き込んでいます…",
  "Shaping tone, rhythm, and breath.":
    "声色、リズム、息づかいを整えています。",
  "Your audio will appear here": "作成した音声がここに表示されます",
  "Listen, compare, and download without leaving the studio.":
    "スタジオ内でそのまま試聴、比較、ダウンロードできます。",
  "sec audio": "秒の音声",
  credits: "クレジット",
  "Create speech": "音声を作成",
  "Sign in & create": "ログインして作成",
  "Your voice data moves only when you choose to create.":
    "音声データは、作成を選んだときだけ送信されます。",
  "Made to refine": "納得いくまで調整",
  "Listen, adjust, and download in one quiet workspace.":
    "同じ画面で、試聴・調整・ダウンロードまで完結します。",
  "Return to a sound": "お気に入りの声へ",
  "Presets and seeds make favorite voices easy to revisit.":
    "プリセットとシードで、好きな声をいつでも再現できます。",
  "BUILT FOR THE WAY STORIES SOUND": "物語の響きのために",
  "A voice is more than a dropdown.": "声は、ただ選ぶだけのものではありません。",
  "SuraYomi gives you the useful controls without making speech feel mechanical. Start with a performer, write a direction in everyday language, then preserve the exact settings when the result feels right.":
    "SuraYomiなら、声の自然さを保ちながら表現を細かく調整できます。声を選び、普段の言葉で読み方を伝え、気に入った設定をそのまま保存できます。",
  "Describe naturally": "自然な言葉で伝える",
  "Ask for a smoky whisper, an excited guide, or anything between.":
    "静かなささやき、明るいガイド、その間にあるどんな表情でも。",
  "Refine precisely": "細部まで調整",
  "Tune pace, expression, focus, consistency, and format.":
    "速さ、表現、フォーカス、一貫性、形式を調整。",
  "Return anytime": "いつでも再現",
  "Saved presets and voice seeds make your sound reproducible.":
    "保存したプリセットとシードで同じ声を再現できます。",
  "“Read this as if you’ve just discovered something wonderful.”":
    "「すてきなものを見つけた瞬間のように読んでください。」",
  "SIMPLE, HONEST PRICING": "シンプルで分かりやすい料金",
  "Begin free. Grow when you’re ready.": "無料で始めて、必要なときに広げる。",
  "More room to create, with secure billing and cancellation anytime.":
    "安心の決済で、もっと自由に制作。いつでも解約できます。",
  forever: "ずっと無料",
  "/ month": "/ 月",
  "For trying ideas and short reads.": "アイデアや短い原稿のお試しに。",
  "50 credits / month": "月50クレジット",
  "All 9 studio voices": "9種類すべてのスタジオ音声",
  "Voice design & cloning": "音声デザインとクローン",
  "WAV and MP3 downloads": "WAV・MP3ダウンロード",
  "For regular creative projects.": "日々のクリエイティブ制作に。",
  "3,000 credits / month": "月3,000クレジット",
  "8,000 credits / month": "月8,000クレジット",
  "Voice cloning uses 1.5× credits.":
    "ボイスクローンは通常の1.5倍のクレジットを使用します。",
  "Extra credit refills": "追加クレジットを購入可能",
  "For frequent and longer-form projects.": "高頻度の利用や長めの原稿に。",
  RECOMMENDED: "おすすめ",
  "CURRENT PLAN": "現在のプラン",
  "Plan active": "利用中のプラン",
  "Start free": "無料で始める",
  "Choose Creator": "Creatorを選ぶ",
  "Choose Studio": "Studioを選ぶ",
  "Loading account…": "アカウントを読み込み中…",
  "Billing temporarily unavailable": "現在お支払いを利用できません",
  "Manage subscription": "サブスクリプションを管理",
  "Change in billing": "請求設定でプランを変更",
  "Secure checkout by Stripe. Plans renew monthly until canceled; cancel anytime in your profile.":
    "Stripeによる安全な決済です。プランは解約するまで毎月更新され、プロフィールからいつでも解約できます。",
  "YOUR NEXT LINE IS WAITING": "次の一行を、声に",
  "Make it heard.": "その言葉を、声に。",
  "50 credits a month. No card. No complicated setup.":
    "毎月50クレジット。カード不要。面倒な設定もありません。",
  "Open the studio": "スタジオを開く",
  "Create your free account": "無料アカウントを作成",
  "Beautifully expressive speech,": "美しく表情豊かな音声を、",
  "crafted from your words.": "あなたの言葉から。",
  Product: "プロダクト",
  Company: "運営",
  Contact: "お問い合わせ",
  Status: "稼働状況",
  Legal: "法務",
  Privacy: "プライバシー",
  Terms: "利用規約",
  "Commercial disclosure": "特定商取引法に基づく表記",
  "Voice consent": "音声利用の同意",
  "Made with care in Japan": "日本から、心を込めて",
  Japanese: "日本語",
  English: "英語",
  Chinese: "中国語",
  Korean: "韓国語",
  German: "ドイツ語",
  French: "フランス語",
  Spanish: "スペイン語",
  Italian: "イタリア語",
  Portuguese: "ポルトガル語",
  Russian: "ロシア語",
  Auto: "自動判定",
  Tokyo: "東京",
  International: "インターナショナル",
  American: "アメリカ",
  Mandarin: "標準中国語",
  Beijing: "北京",
  Sichuan: "四川",
  Seoul: "ソウル",
  "Playful, nimble, and warmly expressive": "軽やかで遊び心があり、温かな表現",
  "Dynamic with a confident rhythmic drive": "自信に満ちたダイナミックなリズム",
  "Sunny, clear, and naturally conversational": "明るくクリアで自然な会話調",
  "Bright, youthful, and slightly editorial": "明るく若々しい、洗練された語り",
  "Warm, gentle, and softly cinematic": "温かく穏やかで、やわらかな映画調",
  "Seasoned, low, and mellow": "深みのある低く落ち着いた声",
  "Youthful with an easy natural timbre": "若々しく自然で親しみやすい音色",
  "Lively, husky, and bright": "活気があり、少しかすれた明るい声",
  "Warm and emotionally rich": "温かく感情豊かな声",
};

export function t(english: string): string {
  return isJapanese ? japanese[english] ?? english : english;
}

export function formatNumber(value: number): string {
  return value.toLocaleString(isJapanese ? "ja-JP" : "en-US");
}
